var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEs = function SvgEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#es_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#es_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M3 6h30v20H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F93939",
    d: "M30.143 6H5.857C4.28 6 3 7.194 3 8.667v14.666C3 24.806 4.28 26 5.857 26h24.286C31.72 26 33 24.806 33 23.333V8.667C33 7.194 31.72 6 30.143 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA2C",
    fillRule: "evenodd",
    d: "M3 11.333h30v9.334H3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4AF2C",
    fillRule: "evenodd",
    d: "M15.857 14.296v3.36c0 .933-.96 1.68-2.143 1.68h-2.857c-1.18-.003-2.143-.753-2.143-1.683v-3.36c0-.762.64-1.4 1.52-1.606.266-.694 1.083-.072 2.051-.072.975 0 1.786-.618 2.052.073.877.212 1.52.85 1.52 1.608",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBCBCB",
    fillRule: "evenodd",
    d: "M15.858 15.333h1.428v4h-1.428zm-8.572 0h1.429v4H7.286z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A47B8",
    fillRule: "evenodd",
    d: "M15.858 18h1.428v1.333h-1.428zm-8.572 0h1.429v1.333H7.286z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4AF2C",
    fillRule: "evenodd",
    d: "M15.858 14h1.428v1.333h-1.428zm-8.572 0h1.429v1.333H7.286z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF010D",
    fillRule: "evenodd",
    d: "M10.143 14h1.428v2h-1.428zM13 16.667h1.428v2H13z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE6A3E",
    fillRule: "evenodd",
    d: "M13 14h1.429v2H13z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA2C",
    fillRule: "evenodd",
    d: "M10.143 16.667h1.428v2h-1.428z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AF010D",
    fillRule: "evenodd",
    d: "m11.571 14-1.428-1.333h4.285L13 14z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4AF2C",
    fillRule: "evenodd",
    d: "M11.571 11.333H13v1.334H11.57z",
    clipRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    d: "M9.4 6.25h13.2c1.124 0 1.952 0 2.607.054.651.053 1.109.158 1.495.355a3.75 3.75 0 0 1 1.64 1.639c.196.386.301.844.354 1.495.054.655.054 1.483.054 2.607v7.2c0 1.124 0 1.952-.054 2.607-.053.651-.158 1.109-.355 1.495a3.75 3.75 0 0 1-1.639 1.64c-.386.196-.844.301-1.495.354-.655.054-1.483.054-2.607.054H9.4c-1.124 0-1.952 0-2.607-.054-.651-.053-1.109-.158-1.495-.355a3.75 3.75 0 0 1-1.64-1.639c-.196-.386-.301-.844-.354-1.495-.054-.655-.054-1.483-.054-2.607v-7.2c0-1.124 0-1.952.054-2.607.053-.651.158-1.109.355-1.495a3.75 3.75 0 0 1 1.639-1.64c.386-.196.844-.301 1.495-.354.655-.054 1.483-.054 2.607-.054Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "es_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "es_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 6h30v20H3z"
  })))));
};
export default SvgEs;